module.exports = "/templates/bds/public/font/a1f868fe40a4547992a515e4059f8717.eot";